import { render, staticRenderFns } from "./filter-review.vue?vue&type=template&id=16fbc9ec&scoped=true"
import script from "./filter-review.vue?vue&type=script&lang=js"
export * from "./filter-review.vue?vue&type=script&lang=js"
import style0 from "./filter-review.vue?vue&type=style&index=0&id=16fbc9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbc9ec",
  null
  
)

export default component.exports